<template>
  <div style="padding: 20px 180px 20px 180px; min-width: 1200px">
    <div class="shadow">
      <div class="product-detail">
        <div class="detail-left">
          <imageView
            v-if="productDetails.images"
            :value="productDetails.images"
            style="
              width: 309px;
              height: 310px;
              object-fit: contain;
              margin: auto;
            "
          ></imageView>
          <!-- <img v-else src="@/assets/img/home/xian.png" alt="图片加载中" /> -->
        </div>
        <div class="detail-right">
          <div class="product-name">{{ productDetails.cpmc }}</div>
          <div class="info-list">
            <div class="info-item">
              <span class="info-label">年利率范围</span>
              <span class="info-value">
                <span v-if="productDetails.zdnhlv && productDetails.zgnhlv"
                  >{{ productDetails.zdnhlv }}%～{{
                    productDetails.zgnhlv
                  }}%</span
                >
                <span
                  v-else-if="productDetails.zdnhlv && !productDetails.zgnhlv"
                  >{{ productDetails.zdnhlv }}%以上</span
                >
                <span
                  v-else-if="!productDetails.zdnhlv && productDetails.zgnhlv"
                  >{{ productDetails.zgnhlv }}%以下</span
                >
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">贷款期限</span>
              <span class="info-value">
                <span v-if="productDetails.dkqxxx && productDetails.dkqxsx"
                  >{{ productDetails.dkqxxx }}～{{
                    productDetails.dkqxsx
                  }}个月</span
                >
                <span
                  v-else-if="productDetails.dkqxxx && !productDetails.dkqxsx"
                  >{{ productDetails.dkqxxx }}个月以上</span
                >
                <span
                  v-else-if="!productDetails.dkqxxx && productDetails.dkqxsx"
                  >{{ productDetails.dkqxsx }}个月以下</span
                >
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">贷款额度</span>
              <span class="info-value">
                <span v-if="productDetails.dkedxx && productDetails.dkedsx"
                  >{{ productDetails.dkedxx }}～{{
                    productDetails.dkedsx
                  }}万</span
                >
                <span
                  v-else-if="productDetails.dkedxx && !productDetails.dkedsx"
                  >{{ productDetails.dkedxx }}万</span
                >
                <span
                  v-else-if="!productDetails.dkedxx && productDetails.dkedsx"
                  >{{ productDetails.dkedsx }}万</span
                >
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">担保方式</span>
              <span class="info-value">{{ productDetails.dbfsm }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">信贷类型</span>
              <span class="info-value">{{ productDetails.dklxm }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">联系人及联系电话</span>
              <span class="info-value"
                >{{ productDetails.khjl }} {{ productDetails.lxrdh }}</span
              >
            </div>
            <div class="info-item">
              <span class="info-label">所属机构</span>
              <span class="info-value">{{ productDetails.jrjgmc }}</span>
            </div>
          </div>
          <div class="detail-btn">
            <span @click="goApply(productDetails.id)">立即申请</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-word">
      <div class="detail-name">融资用途</div>
      <div class="describe" v-html="productDetails.cpms"></div>
    </div>
    <!-- <div class="hot-product">
      <div class="title">热门产品<span class="title-eng">HOT PRODUCT</span>
        <span
          @click="changePage"
          class="changeTxt"
        >换一批
          <i
            data-v-2a931866=""
            class="el-icon-refresh"
          ></i>
        </span>
      </div>
      <div>
        <div class="finanblock2">
          <div
            class="applyamt"
            v-for="item in hotList"
            :key="item.id"
          >
            <p class="apply-name">{{item.jrjgmc}}</p>
            <p class="apply-details1">申请<span style="color:red">{{item.cpcs}}</span>笔</p>
            <p class="apply-details2">{{item.zdnhlv}}%—{{item.zgnhlv}}%</p>
            <p class="apply-details3">{{item.dklxm}}</p>
            <div
              class="apply-descripe"
              style=" border-right: 1px solid gray;"
            >
              <p class="apply-deadline">贷款期限</p>
              <p class="apply-month">{{item.dkqxxx}}-{{item.dkqxsx}}个月</p>

            </div>
            <div class="apply-descripe">
              <p class="apply-deadline">额度</p>
              <p class="apply-month">{{item.dkedxx}}-{{item.item}}万</p>
            </div>
            <div class="apply-btn"  @click="getOtherDetails(item.id)" >查看详情</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import {
  getProductDetail,
  getHotSells,
  applyProduct,
  getIsApplyFor,
} from "@/api";
import "@/assets/css/quill-better-table.css";
import "@/assets/css/quill.snow.css";
import imageView from ".././imageView.vue";
export default {
  name: "ProductsDetail",

  components: {
    imageView,
  },
  data() {
    return {
      userInfoweb: this.$store.state.system.userInfoweb,
      token: this.$store.state.system.token,
      loginFlag: false,
      qydm: "",
      productDetails: {},
      applyList: [],
      hotList: [],
      current: 1,
      totalPage: 0,
    };
  },
  created() {},
  mounted() {
    this.getDetails(this.$route.params.id);
    this.getHotList();
    this.checkToken();
  },
  methods: {
    async getDetails(id) {
      const res = await getProductDetail({
        id: id,
      });
      if (res && res.data) {
        this.productDetails = res.data;
      }
    },

    getOtherDetails(id) {
      this.$router.push("/products/ProductsDetail/" + id);
      window.location.reload();
    },

    async getHotList() {
      const res = await getHotSells({
        size: 4,
        current: this.current,
      });
      if (res && res.data) {
        this.hotList = res.data.records;
        if (!this.totalPage) {
          this.totalPage = Math.ceil(res.data.total / 4);
        }
      }
    },
    goApply(id) {
      if (this.token && this.userInfoweb && this.userInfoweb.type == 4) {
        //是否登录企业端
        getIsApplyFor({ productId: id }).then((res) => {
          if (res.data) {
            this.$confirm("你已经申请该产品，确定要再次申请产品吗？", "", {
              confirmButtonText: "继续申请",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.getApplyProduct(id);
              })
              .catch(() => {});
          } else {
            this.getApplyProduct(id);
          }
        });
      } else {
        this.$confirm("是否登录企业账号？", "", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({
              name: "login",
              query: {
                type: 1,
              },
            });
          })
          .catch(() => {});
      }
    },

    async getApplyProduct(id) {
      const params = {
        productId: id,
        qydm: this.qydm,
      };
      const formData = new FormData();
      for (const key in params) {
        params[key] !== undefined && formData.append(key, params[key]);
      }
      let res = {};
      res = await applyProduct(formData);
      this.$baseMessage("申请成功！", "success");
    },

    changePage() {
      if (this.current == this.totalPage) {
        this.current = 1;
      } else {
        this.current++;
      }
      this.getHotList();
    },
    checkToken() {
      if (
        this.$store.state.system.userInfoweb &&
        this.$store.state.system.userInfoweb.type == 4
      ) {
        this.qydm = this.$store.state.system.userInfoweb.dm;
        this.loginFlag = true;
      } else {
        this.loginFlag = false;
      }
    },
  },
};
</script>
<style scoped>
.shadow {
  /* box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  padding-top: 45px;
  min-height: 340px; */
  background-color: #fff;
  padding: 25px 21px;
  border-radius: 16px;
  position: relative;
}
.product-detail {
  display: flex;
}
.detail-left {
  display: inline;
  text-align: center;
  margin-right: 60px;
}

.detail-left img {
  width: 160px;
  height: 160px;
  object-fit: contain;
  border: 1px solid gray;
  margin: auto;
}
.detail-right {
  flex: 1;
  font-size: 18px;
}

.product-name {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 28px;
  /* line-height: 1.2; */
}

.info-list {
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  /* margin-bottom: 40px; */
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 18px;
  /* line-height: 1.5; */
}

.info-label {
  flex-shrink: 0;
  width: 200px;
  color: #909399;
  font-weight: 500;
}

.info-value {
  flex: 1;
  /* color: #3175ff;
  font-weight: 600; */
  word-break: break-all;
}

.detail-btn {
  position: absolute;
  bottom: 25px;
  right: 30px;
  display: flex;
  justify-content: flex-end;
}

.detail-btn span {
  padding: 0 20px;
  color: white;
  display: flex;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 3px;
  align-self: stretch;
  border-radius: 16px;
  background: radial-gradient(
      56.94% 56.32% at 50% 0%,
      #008bff 0%,
      #008bff00 100%
    ),
    radial-gradient(165.43% 73.9% at 50% 100%, #7157fe 0%, #7157fe00 100%), #07f;
  box-shadow: 0 0 7.9px 0 #fff inset, 0 5px 5px 0 #1366ec21;
  cursor: pointer;
}

.detail-btn span:hover {
  transform: translateY(-1px);
}

/* .describe{
  width: 800px;
  overflow: hidden;
} */
/* .describe>p{
  width:100% !important;
  max-width: 800px !important;
  display: table !important;
} */
.describe >>> img {
  width: 600px !important;
  display: table !important;
  margin: 5px auto !important;
}
/* .describe >>> th,td{
  border: 1px solid #000;
} */
.detail-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.detail-title {
  font-size: 18px;
  font-weight: bold;
  min-width: 90px;
  display: inline-block;
  padding-top: 5px;
}
.detail-text {
  font-size: 16px;
  line-height: 28px;
  display: inline-block;
}
.hot-product {
}

.title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin: 35px 0;
  letter-spacing: 0.3px;
  position: relative;
}
.title-eng {
  color: #cecdcd;
  margin-left: 20px;
}
.hot-product .finanblock2 {
  display: inline-flex;
  justify-content: space-between;
  width: 90%;
  margin-left: 5%;
  height: 400px;
}
.hot-product .finanblock2 .applyamt {
  display: inline-block;
  width: 31%;
  height: 400px;
  background: url("../../assets/img/home/productBack.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 12px;
}
.changeTxt {
  position: absolute;
  font-size: 16px;
  color: gray;
  bottom: 0;
  right: 6%;
  cursor: pointer;
}
.apply-name {
  font-size: 18px;
  font-weight: bold;
  margin-top: 35px;
}
.apply-details1 {
  font-size: 16px;
  margin-top: 25px;
}
.apply-details2 {
  font-size: 20px;
  font-weight: bold;
  color: red;
  margin-top: 25px;
}
.apply-details3 {
  font-size: 16px;
  margin: 25px;
}
.apply-descripe {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  height: 80px;
}
.apply-deadline {
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
}
.apply-month {
  margin-top: 15px;
  font-size: 16px;
}
.apply-btn {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  background-color: #3175ff;
  width: 70%;
  color: white;
  padding: 15px 0;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2%;
  margin-top: 25px;
  cursor: pointer;
}
.apply-btn-false {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  background-color: gray;
  width: 70%;
  color: white;
  padding: 15px 0;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2%;
  margin-top: 25px;
}
.detail-word {
  width: 100%;
  margin-top: 20px;
  font-size: 16px;
  padding: 25px 21px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
}
@media screen and (max-width: 767px) {
  .list-item div {
    padding: 30px;
  }
}
</style>
